"use client";

import { useEffect } from "react";
import { captureBrowserEntryAttribution } from "@/lib/ad-attribution";

export function AdAttributionCapture() {
  useEffect(() => {
    captureBrowserEntryAttribution();
  }, []);

  return null;
}
